import { render, staticRenderFns } from "./u-button.vue?vue&type=template&id=6a6299dd&scoped=true&"
import script from "./u-button.vue?vue&type=script&lang=js&"
export * from "./u-button.vue?vue&type=script&lang=js&"
import style0 from "./u-button.vue?vue&type=style&index=0&id=6a6299dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6299dd",
  null
  
)

export default component.exports